<script setup>
import { Link } from '@inertiajs/vue3'
import { truncate, isClient } from '@/helpers'

const props = defineProps({
	navItems: {
		type: Array,
		default: () => [],
	},
	current: {
		type: String,
		default: '',
	},
	color: {
		type: String,
		default: '',
	},
})

const appStore = useAppStore()

const hasHistory = computed(() => {
	if (!isClient) return false
	return isClient && appStore.previousRoute ? true : false
})

const back = () => window.history.back()
</script>

<template>
	<div
		class="breadcrumb-wrapper"
		:data-history="isClient && appStore.previousRoute ? true : false"
	>
		<button
			v-if="hasHistory"
			class="btn btn-white btn-circle me-2"
			tabindex="-1"
			style="--size: 40px"
			:aria-label="$t('Go back')"
			@click="back()"
		>
			<i class="str-chevron-left-medium" />
		</button>

		<ol
			class="breadcrumb-custom mb-0"
			:class="{
				'text-white': color === 'white',
			}"
		>
			<li
				v-for="(item, breadcrumbIndex) in navItems"
				:key="`breadcrumb-${breadcrumbIndex}`"
				class="breadcrumb-custom-item"
			>
				<Link
					:href="item.route"
					class="feature-link"
					:style="{
						'--link-color': color === 'white' ? color : null,
					}"
				>
					{{ item.label }}
				</Link>
			</li>
			<!-- <li
				v-if="current && !appStore.isMobile"
				class="breadcrumb-item active"
				aria-current="page"
			>
				<span :class="[color !== 'white' ? 'text-neutral-800' : null]">
					{{ truncate(current, appStore.isMobile ? 6 : 8) }}
				</span>
			</li> -->
		</ol>
	</div>
</template>
